import { listCheck, list, alarm, alarmFill } from 'ngx-bootstrap-icons';

export const icons = {
    alarm,
    alarmFill,
    listCheck,
    list,
};
